import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const InvoiceV2CollectionMethodDropdown = (props: DropdownWithoutOptionsProps<server.dto.InvoiceCollectionMethod>) => {
  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={serverReference.invoiceCollectionMethods.filter(o => o.value !== "unknown")}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    config={props.config}
  />;
};

export default InvoiceV2CollectionMethodDropdown;